import React from "react";

// Navigate
import { useLocation, useNavigate, useParams } from "react-router-dom";

//import debounce library
import { useDebouncedCallback } from "use-debounce";

// Mui
import Box from "@mui/material/Box";
import Fade from "@mui/material/Fade";
import Grid from "@mui/material/Grid2";
import TextField from "@mui/material/TextField";
// import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";

import Autocomplete from "@mui/material/Autocomplete";

// import FormControl from "@mui/material/FormControl";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import Checkbox from "@mui/material/Checkbox";
import FormHelperText from "@mui/material/FormHelperText";
import MenuItem from "@mui/material/MenuItem";
// Mui Styles
import { StyledButton, StyledPaper } from "@/styles/mui/globalStyles";
import { createTheme, ThemeProvider } from "@mui/material/styles";

// Components
import Layout from "@/components/layout";
import Title from "@/components/title";

//lodash
import _ from "lodash";

//fetch
import { getAllWorkLocationManage } from "@/fetch/fetchProduct";
import {
  createWorkLocation,
  getAddresDetails,
  getRegionOptions,
  updatedWorkLocationManage,
} from "@/fetch/fetchWork";
import { Icon } from "leaflet";
import defaultIconPng from "leaflet/dist/images/marker-icon.png";
import {
  Circle,
  FeatureGroup,
  MapContainer,
  Marker,
  TileLayer,
  useMap,
} from "react-leaflet";

// Redux
import {
  optionsDefaultValue,
  workLocationList,
} from "@/features/workLocationManageSlice";
import { useCurrentAction } from "@/hooks/user";
import { useDispatch, useSelector } from "react-redux";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const defaultIcon = new Icon({
  iconUrl: defaultIconPng,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

const WorkLocationManageDetailPage = (props) => {
  const { open, setOpen } = props;
  const actions = useCurrentAction();

  //ref
  const onChangeDataRef = React.useRef({});

  const { id } = useParams();
  const markerRef = React.useRef(null);

  // Navigate and Location and Params
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();

  //retrieve the options through the state value of previous page
  const options = location.state.options;

  //reduxState
  const workLocationManageRedux = useSelector(
    (state) => state.workLocationManage
  );
  const dispatch = useDispatch();

  // States
  const [onChangeData, setOnChangeData] = React.useState({});
  const [error, setError] = React.useState({
    work_address: false,
    work_district: false,
    work_name: false,
    work_shortcode: false,
    work_telephone: false,
    isExist: false,
  });
  const [save, setSave] = React.useState(false);
  const [natureOption, setNatureOption] = React.useState([]);
  const [slideTranOn, setSlideTranOn] = React.useState(false);
  const [snackMessage, setSnackMessage] = React.useState("");
  const [regions, setRegions] = React.useState([]);
  const [districts, setDistricts] = React.useState({});
  const [areas, setAreas] = React.useState({});
  const [snackOpen, setSnackOpen] = React.useState(false);
  const theme = createTheme({
    components: {
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: 16,
            marginBottom: 10,
          },
        },
      },
    },
  });

  // Submit
  const onClickSubmit = async (id) => {
    const shopData = {
      administrator: onChangeData.administrator,
      shopId: onChangeData.id,
      work_address: onChangeData.work_address,
      work_district: onChangeData.work_district,
      work_name: onChangeData.work_name,
      work_shortcode: onChangeData.work_shortcode,
      work_telephone: onChangeData.work_telephone,
      work_region_id: onChangeData.work_region_id,
      work_area_id: onChangeData.work_area_id,
      work_district_id: onChangeData.work_district_id,
      nature: onChangeData.nature,
      lat: onChangeData.lat,
      lng: onChangeData.lng,
      radius: onChangeData.radius,
    };

    /* Calculate the added value*/
    const mergedOldAndNew = _.union(
      onChangeDataRef.current,
      shopData.administrator
    );

    const addedValue = _.difference(
      mergedOldAndNew,
      onChangeDataRef.current
    ).map((item) => ({ adminId: item, shopId: id, isDelete: false }));
    //////////////////////////////////////////////////////

    /* Calculate the deleted Value */
    const shopDataRemovedAddedValue = _.pullAll(
      shopData.administrator,
      addedValue
    );

    const deletedValue = _.difference(
      onChangeDataRef.current,
      shopDataRemovedAddedValue
    ).map((item) => ({ adminId: item, shopId: id, isDelete: true }));
    ////////////////////////////////////////////////////////

    const reqBody = {
      updatedShopData: shopData,
      updatedUsersPermission: _.union(deletedValue, addedValue),
    };

    const checkError = {
      work_address: shopData.work_address ? false : true,
      work_region_id: shopData.work_region_id ? false : true,
      work_area_id: shopData.work_area_id ? false : true,
      work_district_id: shopData.work_district_id ? false : true,
      work_name: shopData.work_name ? false : true,
      work_shortcode: shopData.work_shortcode ? false : true,
      work_telephone: shopData.work_telephone ? false : true,
      isExist: workLocationManageRedux.workLocationList.find(
        (item) =>
          item.work_shortcode.toUpperCase() ===
          onChangeData.work_shortcode?.toUpperCase()
      )
        ? true
        : false,
    };

    setError((prev) => ({
      ...prev,
      ...checkError,
    }));

    if (checkError.isExist) {
      return false;
    }

    if (
      !checkError.work_address &&
      !checkError.work_district_id &&
      !checkError.work_name &&
      !checkError.work_shortcode &&
      !checkError.work_telephone
    ) {
      await updatedWorkLocationManage(reqBody).then((data) => {
        if (data && data.results) {
          setSnackMessage("已修改");
          setSnackOpen(true);
          setSave((prev) => !prev);
          setTimeout(() => {
            setSnackOpen(false);
            navigate(-1);
          }, 1500);
        }
      });
    } else {
      setSnackMessage("請填寫資料");
      setSnackOpen(true);
    }
  };

  const onClickSubmitCreate = async (id) => {
    const shopData = {
      administrator: onChangeData.administrator,
      work_address: onChangeData.work_address,
      work_district: onChangeData.work_district,
      work_name: onChangeData.work_name,
      work_shortcode: onChangeData.work_shortcode,
      work_telephone: onChangeData.work_telephone,
      work_region_id: onChangeData.work_region_id,
      work_district_id: onChangeData.work_district_id,
      work_area_id: onChangeData.work_area_id,
      nature: onChangeData.nature,
      lat: onChangeData.lat,
      lng: onChangeData.lng,
      radius: onChangeData.radius,
    };

    const reqBody = {
      updatedShopData: shopData,
    };

    const checkError = {
      work_address: shopData.work_address ? false : true,
      work_region_id: shopData.work_region_id ? false : true,
      work_area_id: shopData.work_area_id ? false : true,
      work_district_id: shopData.work_district_id ? false : true,
      work_name: shopData.work_name ? false : true,
      work_shortcode: shopData.work_shortcode ? false : true,
      work_telephone: shopData.work_telephone ? false : true,
      isExist: workLocationManageRedux.workLocationList.find(
        (item) =>
          item.work_shortcode.toUpperCase().trim() ===
          onChangeData.work_shortcode?.toUpperCase().trim()
      )
        ? true
        : false,
    };

    setError((prev) => ({
      ...prev,
      ...checkError,
    }));

    if (checkError.isExist) {
      return false;
    }

    if (
      !checkError.work_address &&
      !checkError.work_name &&
      !checkError.work_shortcode &&
      !checkError.work_telephone &&
      !checkError.work_region_id &&
      !checkError.work_area_id &&
      !checkError.work_district_id
    ) {
      await createWorkLocation(reqBody).then((data) => {
        if (data && data.results) {
          setSnackMessage("已新增");
          setSnackOpen(true);
          setSave((prev) => !prev);
          setTimeout(() => {
            setSnackOpen(false);
            navigate(-1);
          }, 1500);
        }
      });
    } else {
      setSnackMessage("請填寫資料");
      setSnackOpen(true);
    }
  };

  const fetchAllCreate = async () => {
    await getAllWorkLocationManage().then((data) => {
      if (data && data.results) {
        dispatch(workLocationList(data.data));
      }
    });
  };

  const fetchAll = async () => {
    await getAllWorkLocationManage()
      .then((data) => {
        let value;
        if (data && data.results) {
          value = data.data.find((item) => item.id === parseInt(params.id));
          if (!value.lat) {
            value.lat = 22.372842540206822;
          }
          if (!value.lng) {
            value.lng = 114.1070763476067;
          }
          const distinctNature = _.unionBy(data.data, "nature");
          setNatureOption(distinctNature);
          setOnChangeData(value);
          // make a copy of initial data of work Location from API for reference
          onChangeDataRef.current = value.administrator;
        }
        return value;
      })
      .then((value) => {
        if (value) {
          //setting defaultValue of options for select  & checkbox component
          const defaultValue = location.state.options.filter((option) => {
            let isAdmin = false;
            value.administrator?.forEach((adminId) => {
              if (option.id === adminId) isAdmin = true;
            });
            return isAdmin;
          });
          //store into redux storage
          dispatch(optionsDefaultValue(defaultValue));
          setSlideTranOn(true);
        }
      });
  };
  const fetchRegion = async () => {
    const { data: workOptions } = await getRegionOptions();
    setRegions(
      _.map(_.uniqBy(workOptions, "region_id"), (option) => ({
        region_id: option.region_id,
        region_name: option.region_name,
      }))
    );
    setDistricts(_.groupBy(_.uniqBy(workOptions, "district_id"), "region_id"));
    setAreas(_.groupBy(_.uniqBy(workOptions, "area_id"), "district_id"));
  };

  // Browser Back
  const handleBeforeUnload = (e) => {
    e.preventDefault();
    const message =
      "Are you sure you want to leave? All provided data will be lost.";
    e.returnValue = message;
    return message;
  };
  const eventHandlers = React.useMemo(
    () => ({
      dragend() {
        const marker = markerRef.current;
        if (marker != null) {
          setOnChangeData((prev) => ({
            ...prev,
            ...marker.getLatLng(),
          }));
        }
      },
    }),
    []
  );

  const getAddressAndSetOnChange = useDebouncedCallback(async (addName) => {
    try {
      const { data } = await getAddresDetails(addName);
      const { geometry } = data;
      if (!_.isEmpty(data)) {
        setOnChangeData((prev) => ({
          ...prev,
          lat: geometry.location.lat,
          lng: geometry.location.lng,
        }));
      } else {
        setOnChangeData((prev) => ({
          ...prev,
          lat: 0,
          lng: 0,
        }));
      }
    } catch (err) {
      if (err)
        setOnChangeData((prev) => ({
          ...prev,
          lat: 0,
          lng: 0,
        }));
    }
  }, 1000);

  React.useEffect(() => {
    fetchRegion();
    if (!id) {
      fetchAllCreate();
    }

    /*if a param id is passed inside , it means that this is a existing record and then execute fetchAll function to retrieve the related information to display,
    otherwise this will a new record  i won't execute fetchAll and clear option defultValues in reduxState */
    if (id) {
      fetchAll();
    } else {
      setSlideTranOn(true);
      dispatch(optionsDefaultValue());
    }
    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    // eslint-disable-next-line react-hooks/exhaustive-deps
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      dispatch(workLocationList([]));
    };
  }, [save]);

  const innerMapProps = React.useMemo(
    () => ({
      position: [onChangeData.lat, onChangeData.lng],
      eventHandlers,
      markerRef,
      radius: onChangeData.radius,
      actions,
    }),
    [onChangeData.lat, onChangeData.lng, onChangeData.radius]
  );

  React.useEffect(
    () => console.log("onChangeData", onChangeData),
    [onChangeData]
  );

  return (
    <Layout
      header="workLocationManageDetailPage"
      snackOpen={snackOpen}
      snackClose={() => setSnackOpen(false)}
      snackMessage={snackMessage}
      selectedIndex={16}
      open={open}
      setOpen={setOpen}
    >
      <Title
        title={`店舖管理 / ${id ? "修改店舖" : "新增店舖"}`}
        history={() => navigate(-1)}
      />
      <Fade in={slideTranOn} mountOnEnter unmountOnExit>
        <StyledPaper page={"yes"}>
          <ThemeProvider theme={theme}>
            <Box validate="true" sx={{ width: 1, flex: 1 }}>
              <Grid container spacing={2}>
                <Grid
                  size={{
                    xs: 12,
                    md: 6,
                    lg: 6
                  }}>
                  <TextField
                    disabled={!actions?.update}
                    id="work_shortcode"
                    name="work_shortcode"
                    label="店舖編號"
                    error={error.isExist || error.work_shortcode}
                    value={onChangeData.work_shortcode}
                    onChange={(event) => {
                      setOnChangeData({
                        ...onChangeData,
                        [event.target.name]: event.target.value,
                      });
                      setError((prev) => ({
                        ...prev,
                        isExist: workLocationManageRedux.workLocationList.find(
                          (item) =>
                            item.work_shortcode.toUpperCase().trim() ===
                            event.target.value?.toUpperCase().trim()
                        )
                          ? true
                          : false,
                      }));
                    }}
                    sx={{ width: "100%" }}
                  />
                  {/*if a param id is passed inside , it means that this is a existing record and it will disable validation,
                     otherwise this will a new record  it will enable validation */}
                  {!params.id
                    ? error.isExist && (
                        <FormHelperText
                          error={!params.id ? error.isExist : false}
                        >
                          店舖編號已存在
                        </FormHelperText>
                      )
                    : false}
                  {/*///////////////////////////////////////////////////////////////////////////////////////*/}
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    md: 6,
                    lg: 6
                  }}>
                  <TextField
                    disabled={!actions?.update}
                    id="work_name"
                    name="work_name"
                    label="店舖名稱"
                    error={error.work_name}
                    value={onChangeData.work_name}
                    onChange={(event) => {
                      setOnChangeData({
                        ...onChangeData,
                        [event.target.name]: event.target.value,
                      });
                    }}
                    sx={{ width: "100%" }}
                  />
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    md: 4,
                    lg: 4
                  }}>
                  <TextField
                    disabled={!actions?.update}
                    id="outlined-select"
                    label="店舖電話"
                    name="work_telephone"
                    error={error.work_telephone}
                    value={onChangeData.work_telephone}
                    onChange={(event) =>
                      setOnChangeData({
                        ...onChangeData,
                        [event.target.name]: event.target.value,
                      })
                    }
                    sx={{ width: "100%" }}
                  ></TextField>
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    md: 4,
                    lg: 4
                  }}>
                  <Autocomplete
                    options={natureOption.map((option) => option.nature)}
                    name="種類"
                    value={onChangeData.nature}
                    freeSolo
                    onChange={(event, newValue) => {
                      setOnChangeData({
                        ...onChangeData,
                        nature: newValue,
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Profile"
                        onChange={(event) =>
                          setOnChangeData({
                            ...onChangeData,
                            nature: event.target.value,
                          })
                        }
                        placeholder="Profile"
                      />
                    )}
                  />
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    md: 4,
                    lg: 4
                  }}>
                  <Grid container spacing={2}>
                    <Grid
                      size={{
                        xs: 12,
                        md: 12,
                        lg: 12
                      }}>
                      <Autocomplete
                        disabled={!actions?.update}
                        multiple
                        name="administrator"
                        id="administrator"
                        options={options}
                        defaultValue={
                          workLocationManageRedux.optionsDefaultValue
                        }
                        disableCloseOnSelect
                        onChange={(event, newValue) => {
                          const administrator = newValue.map((item) => item.id);
                          setOnChangeData({
                            ...onChangeData,
                            administrator,
                          });
                        }}
                        isOptionEqualToValue={(option, value) =>
                          option.id === value.id
                        }
                        getOptionLabel={(option) => option.alias}
                        renderOption={(props, option, { selected }) => {
                          return (
                            <li {...props}>
                              <Checkbox
                                icon={icon}
                                checkedIcon={checkedIcon}
                                style={{ marginRight: 8 }}
                                checked={selected}
                              />
                              {option?.alias}
                            </li>
                          );
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="店鋪權限"
                            placeholder="店鋪權限"
                          />
                        )}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    md: 6,
                    lg: 6
                  }}>
                  <TextField
                    disabled={!actions?.update}
                    select
                    id="work_region_id"
                    name="work_region_id"
                    label="Region"
                    error={error.work_region_id}
                    value={onChangeData.work_region_id ?? ""}
                    onChange={(event) =>
                      setOnChangeData({
                        ...onChangeData,
                        [event.target.name]: event.target.value,
                      })
                    }
                    sx={{ width: "100%" }}
                  >
                    <MenuItem disabled>請選擇</MenuItem>
                    {_.map(regions, (item, index) => (
                      <MenuItem key={index} value={item.region_id}>
                        {item.region_name}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    md: 6,
                    lg: 6
                  }}>
                  <TextField
                    disabled={!actions?.update}
                    select
                    id="work_district_id"
                    name="work_district_id"
                    label="District"
                    error={error.work_district_id}
                    value={onChangeData.work_district_id ?? ""}
                    onChange={(event) =>
                      setOnChangeData({
                        ...onChangeData,
                        [event.target.name]: event.target.value,
                      })
                    }
                    sx={{ width: "100%" }}
                  >
                    <MenuItem disabled>請選擇</MenuItem>
                    {_.map(
                      districts?.[onChangeData?.work_region_id],
                      (item, index) => {
                        return (
                          <MenuItem key={index} value={item.district_id}>
                            {item.district_name}
                          </MenuItem>
                        );
                      }
                    )}
                  </TextField>
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    md: 6,
                    lg: 6
                  }}>
                  <TextField
                    disabled={!actions?.update}
                    select
                    id="work_area_id"
                    name="work_area_id"
                    label="Area"
                    error={error.work_area_id}
                    value={onChangeData.work_area_id ?? ""}
                    onChange={(event) => {
                      console.log("event", event.target.value);
                      setOnChangeData({
                        ...onChangeData,
                        [event.target.name]: event.target.value,
                      });
                    }}
                    sx={{ width: "100%" }}
                  >
                    <MenuItem disabled>請選擇</MenuItem>
                    {_.map(
                      areas?.[onChangeData?.work_district_id],
                      (item, index) => {
                        return (
                          <MenuItem key={index} value={item.area_id}>
                            {item.area_name}
                          </MenuItem>
                        );
                      }
                    )}
                  </TextField>
                </Grid>
                {/* <Grid item xs={12} md={6} lg={6}>
                  <TextField
                    select
                    id="work_region"
                    name="work_region"
                    label="店舖地區"
                    error={error.work_region}
                    value={onChangeData.work_region}
                    onChange={(event) =>
                      setOnChangeData({
                        ...onChangeData,
                        [event.target.name]: event.target.value,
                      })
                    }
                    sx={{ width: "100%" }}
                  >
                    <MenuItem disabled>請選擇</MenuItem>
                    {["香港", "澳門"].map((item, index) => {
                      return (
                        <MenuItem key={index} value={item}>
                          {item}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <TextField
                    select
                    id="work_district"
                    name="work_district"
                    label="店舖地區"
                    error={error.work_district}
                    value={onChangeData.work_district}
                    onChange={(event) =>
                      setOnChangeData({
                        ...onChangeData,
                        [event.target.name]: event.target.value,
                      })
                    }
                    sx={{ width: "100%" }}
                  >
                    <MenuItem disabled>請選擇</MenuItem>
                    {["香港", "九龍", "新界", "澳門", "其他"].map(
                      (item, index) => {
                        return (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        );
                      }
                    )}
                  </TextField>
                </Grid> */}
                <Grid
                  size={{
                    xs: 12,
                    md: 6,
                    lg: 6
                  }}>
                  <TextField
                    disabled={!actions?.update}
                    id="radius"
                    name="radius"
                    label="半徑範圍（米）"
                    error={error.radius}
                    value={onChangeData.radius}
                    onChange={(event) =>
                      setOnChangeData({
                        ...onChangeData,
                        [event.target.name]: event.target.value,
                      })
                    }
                    sx={{ width: "100%" }}
                  />
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    md: 12,
                    lg: 12
                  }}>
                  <TextField
                    disabled={!actions?.update}
                    id="work_address"
                    name="work_address"
                    label="店舖地址"
                    error={error.work_address}
                    value={onChangeData.work_address}
                    onChange={async (event) => {
                      setOnChangeData({
                        ...onChangeData,
                        [event.target.name]: event.target.value,
                      });
                      getAddressAndSetOnChange(event.target.value);
                    }}
                    sx={{ width: "100%" }}
                  />
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    md: 12,
                    lg: 12
                  }}>
                  {onChangeData.lat && onChangeData.lng ? (
                    <MapContainer
                      center={[onChangeData.lat, onChangeData.lng]}
                      zoom={17}
                      scrollWheelZoom={false}
                    >
                      <TileLayer
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                      />
                      <InnerMap {...innerMapProps} />
                    </MapContainer>
                  ) : (
                    <></>
                  )}
                </Grid>
                {actions?.update && (
                  <Grid
                    size={{
                      xs: 12,
                      md: 12,
                      lg: 12
                    }}>
                    <Grid justifyContent={"flex-end"} container spacing={2}>
                      <Grid
                        size={{
                          xs: 12,
                          md: 12,
                          lg: 2
                        }}>
                        <StyledButton
                          variant="contained"
                          size="small"
                          onClick={
                            id
                              ? () => onClickSubmit(id ? id : 0)
                              : () => onClickSubmitCreate(id ? id : 0)
                          }
                        >
                          <Typography
                            variant="subtitle1"
                            noWrap
                            component="div"
                          >
                            確認
                          </Typography>
                        </StyledButton>
                      </Grid>
                    </Grid>
                  </Grid>
                )}
              </Grid>
            </Box>
          </ThemeProvider>
        </StyledPaper>
      </Fade>
    </Layout>
  );
};

const InnerMap = React.memo((props) => {
  const map = useMap();
  map.setView(
    { lat: props.position[0], lng: props.position[1] },
    map.getZoom()
  );
  return (
    <React.Fragment>
      <Marker
        icon={defaultIcon}
        position={props.position}
        draggable={props.actions?.update}
        eventHandlers={props.eventHandlers}
        ref={props.markerRef}
      ></Marker>
      <FeatureGroup pathOptions={{ color: "red" }}>
        <Circle center={props.position} radius={props.radius} />
      </FeatureGroup>
    </React.Fragment>
  );
});

export default WorkLocationManageDetailPage;
